<template>
  <div class="vip vipIos">
    <!--<div class="vip-scroll">-->
    <VipHead :isBuy="isBuy">
      <template slot="userPic">
        <img :src="userPic" v-if="userPic" alt="" >
        <img v-else src="./images/default-avater.png" alt="">
      </template>
      <template slot="userName">
        {{userName || '畅学卡会员' | lengthCut(10 )}}
      </template>
      <template slot="endDate">
        {{ endDate | dateFilter}}
      </template>
    </VipHead>
    <div class="bitmap">
      <img src="./images/ios/img-01.png" alt="">
    </div>
    <swiper :options="photoOptions" class="vipIos-swiper">
      <swiper-slide class="bitmap vipIos-slide">
        <img src="./images/ios/tab-01.png" alt="">
      </swiper-slide>
      <swiper-slide class="bitmap">
        <img src="./images/ios/tab-02.png" alt="">
      </swiper-slide>
      <div class="pagination" slot="pagination"></div>
    </swiper>
    <ul class="vipIos-card">
      <li v-for="(item, index) in cardList"
        :class="{'chooseActive': selectType === index}"
        :key="index" @click="chooseType(item, index)"
        v-show="index > 0"
      >
        <div class="vipIos-card-icon" v-if="!index && item.firstPrice !== item.price">
          新用户首月{{item.firstPrice}}元
        </div>
        <p class="vipIos-card-head">{{item.title}}</p>
        <p class="vipIos-card-price">{{item.price}}</p>
      </li>
    </ul>
    <div class="vipIos-buy" @click="pay">
      <img src="./images/ios/button.png" alt="">
    </div>
    <div class="vipIos-desc" v-if="!selectType">
      <h1>畅学卡按月自动续费声明：</h1>
      <p>价格：首月48元，第二个月自动续费58元/月；</p>
      <p>付款：用户确认购买并付款后记入iTunes账户；</p>
      <p>取消续订：用户可自己管理订阅，可随时取消；若需取消自动续费，请在到期前至少24小时设置关闭自动续费，否则订阅会自动续订；关闭后不再扣费；取消步骤为：在iTunes/Apple ID设置管理中，点击取消订阅关闭自动续费；
      </p>
      <p>续费：苹果iTunes账户会在到期前24小时内扣费，扣费成功后订阅周期顺延一个订阅周期。</p>
      <p>试用：如果提供免费试用期，任何未使用的部分将在用户购买该出版物的订阅时被没收（如果适用）</p>
      <div class="vipIos-desc-bottom">
        <span @click="topage('/ios-rule')">会员服务协议 ></span>
        <span @click="topage('/ios-sign-rule')">自动续费协议 ></span>
        <span @click="topage('/protocol')">隐私协议 ></span>
        <span @click="recoverPay()">恢复购买></span>
      </div>
    </div>
    <div class="vipIos-courses">
      <h1>VIP精品推荐</h1>
      <swiper :options="courseOptions">
        <swiper-slide
          v-for="(item, index) in topCourseList"
          :key="index"
          @click="toUse(1, item.id)"
          class="vipIos-courses-slide"
        >
          <course-item
            :course="item"
            class="courseItem"
          />
        </swiper-slide>
      </swiper>
      <div @click="toUse(0)" class="vipIos-courses-checkMore">
        查看更多精选好课 >
      </div>
      <div class="bitmap">
        <img src="./images/ios/image-03.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  import './style.scss'
  import keys from 'lodash.keys'
  import api from '@edu-fe/api'
  import module from '../../modules/vip/vip'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import os from '@edu-fe/os'
  import VipHead from '../../components/Vip/VipHead'
  import CourseItem from '../../components/CourseItem'

  export default {
    data () {
      return {
        photoOptions: {
          pagination: {
            el: '.pagination',
            type: 'bullets',
            bulletElement : 'li',
            bulletClass : 'bullet',
            bulletActiveClass: 'bullet-active',
          }
        },
        courseOptions: {
          slidesPerView: 'auto',
          slidesOffsetAfter: 40,
        },
        topCourseList: [],
        selectType: 1,
        // cardId: 0
        timer: null
      }
    },
    computed: {
      ...mapState(module.name, keys(module.state())),
      ...mapGetters(module.name, keys(module.getters)),
      cardId () {
        const item = this.cardList[this.selectType]
        return item.productId || item.courseId
      }
    },
    watch: {
      cardList: {
        handler (val) {
          if (this.isBuy || this.signStatus === 2) {
            clearInterval(this.timer)
          }
        },
        deep: true
      }
    },
    methods: {
      ...mapMutations(module.name, keys(module.mutations)),
      ...mapActions(module.name, keys(module.actions)),
      recoverPay () {
        return os.sdk.view.goto('restoreGoods', {})
      },
      topage (path) {
        let url = `https://edu-m.wps.cn${path}`
        return os.sdk.view.goto('onJump', {
          "jumpType":"2",
          "jumpUrl": JSON.stringify({
            "vc":"KSNormalWebViewController",
            "urlString":url,
            "title": this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '微课系统'
          })
        })
      },
      jumpTo (target, data) {
        return os.sdk.view.goto(target, data)
      },
      toUse (isCourse, courseId) {
        if (!isCourse) {
          return this.jumpTo('recommend')
        }
        return this.jumpTo('sign-up', { courseId: courseId})
      },
      async getCourseList () {
        const { data } = await api.recommend.getTopLists(1, 10)()
        this.topCourseList = data.list
      },
      chooseType (card, index) {
        this.selectType = index
        // this.cardId = card.courseId
      },
      async pay () {
        if (this.signStatus === 2 || this.isBuy) {
          return this.$toast.show({ message: '您已是畅学卡用户，请勿重复购买' })
        }
        this.timer = setInterval(() => {
          this.getPrivilegeDetail()
        }, 300)
        if (!this.selectType) {
          return os.sdk.pay.call({
            goodId: 'com.kingsoft.WPSExcellentClass.AutoObstructedCardOneMonth',
            goodType: 8
          })
        }
        // const isNewVersion = parseFloat(JSON.parse(await os.sdk.use('getInformation')).v) >= 1.4
        return os.sdk.pay.call({
          // goodId: 'com.kingsoft.WPSExcellentClass.UnobstructedCard1year',
          goodId: this.cardId,
          // goodId: isNewVersion ? 'com.kingsoft.WPSExcellentClass.UnobstructedCard1year' : this.cardId,
          goodType: 8
        })
      }
    },
    filters: {
      dateFilter (val) {
        if (!val)  {
          return '每天不到2元钱，畅学180+精品好课'
        } else {
          return `${moment(val).format('YYYY年MM月DD日')}过期`
        }
      },
      lengthCut (val, len = 4) {
        if (!val) return ''
        return val.length > len ? `${val.slice(0,len)}..`:val
      }
    },
    beforeCreate () {
      this.$store.registerModule(module.name, module)
    },
    created () {
      this.init()
      this.getCourseList()
    },
    mounted () {
    },
    beforeDestroy () {
      clearInterval(this.timer)
      this.$store.unregisterModule(module.name)
    },
    components: {
      VipHead,
      CourseItem
    }
  }
</script>
<style lang="scss" scoped>
  @import "./style.scss";
  .vipIos {
    &-desc {
      top: rem(-50);
    }
    .bitmap {
      width: 100%;
      > img {
        width: 100%;
      }
    }
    .chooseActive {
      border: rem(3) solid #B88B53;
      background: rgba(#BB9357, .2);
    }
    &-swiper {
      .pagination {
        text-align: center;
        .bullet {
          width: rem(30);
          height: rem(6);
          margin-right: rem(14);
          display: inline-block;
          background-color: #D8D8D8;
          &-active {
            background-color: #B88B53;
          }
        }
      }
    }
    &-slide {
      margin-bottom: rem(30);
    }

    &-card {
      padding: rem(59)  rem(30);
      > li {
        position: relative;
        min-width: rem(210);
        height: rem(173);
        margin-right: rem(30);
        background-color: #F5F5F5;
        display: inline-block;
        border-radius: rem(10);
        font-weight: bold;
        line-height: 1.4;
        padding: rem(35) rem(30);
        box-sizing: border-box;
      }
      &-head {
        color: #333333;
        font-size: rem(30);
      }
      &-icon {
        position: absolute;
        padding: rem(8) rem(12);
        top: rem(-20);
        left: 0;
        font-size: rem(22);
        color: #fff;
        background: linear-gradient(to bottom, #FED485, #25170C);
        border-radius: rem(10) rem(0);
      }
      &-price {
        font-size: rem(58);
        color: #B88B53;
        &:before {
          content: '￥';
          font-size: rem(38);
        }
      }
    }
    &-buy {
      width: rem(690);
      margin: auto;
      > img {
        width: 100%;
      }
    }
    &-desc {
      margin-top: rem(40);
      line-height: 1.4;
      padding: 0 rem(30);
      h1 {
        font-size: rem(28);
        font-weight: bold;
      }
      p {
        font-size: rem(26);
        color: #333333;
        margin: rem(10) 0;
      }
      &-bottom {
        padding: rem(25) 0;
        border-top: 1px solid #EBEBEB;
        > span {
          font-size: rem(24);
          /*padding: rem(15) 0;*/
          display: inline-block;
          margin-right: rem(30);
        }
      }
    }
    &-courses {
      h1 {
        font-size: rem(34);
        color: #333;
        font-weight: bold;
        padding-top: rem(15);
        padding-left: rem(30);
      }
      &-slide {
        width: 90%!important;
      }
      &-checkMore {
        color: #333333;
        font-size: rem(26);
        padding-left: rem(30);
      }
    }
  }
</style>
